module.exports = __webpack_public_path__ + "static/media/instapage10.e0f6e902.png";